import { render, staticRenderFns } from "./CarNumberText.vue?vue&type=template&id=3da3a339&"
import script from "./CarNumberText.vue?vue&type=script&lang=js&"
export * from "./CarNumberText.vue?vue&type=script&lang=js&"
import style0 from "./CarNumberText.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports